import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SentEmailDetailModel } from 'lemunzo-api';
import { SharedDialogShellConfig } from '../../models/shared-dialog-shell-config';
import { TranslateDatePipe } from '../../pipes/translate-date.pipe';
import { SharedDialogShellComponent } from '../shared-dialog-shell/shared-dialog-shell.component';

@Component({
    selector: 'apcam-sent-email-detail-dialog',
    templateUrl: './sent-email-detail-dialog.component.html',
    styleUrl: './sent-email-detail-dialog.component.scss',
    imports: [
        MatButtonModule,
        MatIconModule,
        SharedDialogShellComponent,
        TranslateDatePipe,
        TranslatePipe,
    ],
})
export class SentEmailDetailDialogComponent {
    protected get dialogShellConfig(): SharedDialogShellConfig<void> {
        return {
            title: this.translateService.instant(
                'shared.sentEmailDetail.title'
            ),
            cancelLabel: this.translateService.instant('shared.buttons.close'),
            cancelIcon: 'close',
            showConfirmButton: false,
        };
    }

    public emailDetail: SentEmailDetailModel;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: SentEmailDetailModel,
        private readonly translateService: TranslateService
    ) {
        this.emailDetail = data;
    }
}
